import * as React from "react";
import { Spinner, SpinnerSize, Tab, Tabs } from "@blueprintjs/core";
import { useCommonHooks, useEditRouteParams } from "../../hooks";
import { useQuery } from "react-query";

import { ERoutes } from "../../AppRouter";
import { BackButton, PageBase } from "../../components";
import MentionDetailPanel from "./MentionDetailPanel";

export interface MentionItemPageProps {}

export const MentionItemPage: React.FunctionComponent<
  MentionItemPageProps
> = () => {
  const { t, router, apis } = useCommonHooks();
  const { id, tab } = useEditRouteParams();

  const { data: displayName, isFetching: loadingDisplayName } = useQuery(
    ["mention-display-name", id],
    async () => {
      if (+id > 0) {
        return await apis.mentions.getDisplayName(+id);
      }
      return t("NewMention");
    }
  );

  const breadCrumbs = React.useMemo(() => {
    return [
      { text: t("Mentions"), route: ERoutes.mentions },
      {
        text: loadingDisplayName ? (
          <Spinner size={SpinnerSize.SMALL} />
        ) : (
          displayName.text
        ),
      },
    ];
  }, [displayName, loadingDisplayName, t]);

  return (
    <PageBase breadCrumbs={breadCrumbs}>
      <Tabs
        selectedTabId={tab}
        onChange={(nextTabId) =>
          router.push(`${ERoutes.mentions}/${id}/${nextTabId}`)
        }
      >
        <BackButton backRoute={ERoutes.mentions} />
        <Tab
          id="details"
          title={t("MentionDetails")}
          panel={<MentionDetailPanel mentionId={+id} />}
        />
      </Tabs>
    </PageBase>
  );
};

export default MentionItemPage;
